import { SkeletonView } from "./SkeletonView";
export default SkeletonView;
